import { TotalDetailProps } from './interface'

export function withTotalDetail(Component: React.FC<TotalDetailProps>) {
  function WithTotalDetail(props: TotalDetailProps) {
    return <Component {...props} />
  }
  return WithTotalDetail
}
